import usePlaceOrderHelper from "features/payment-helpers/usePlaceOrderHelper";
import { useDispatch, useSelector } from "react-redux";
import { createPaymentIntent } from "./payby.utils";
import { UTILS } from "utils";
import { PaymentMethodAction } from "store/actions";
import { useParams } from "react-router-dom";
import useQueryParam from "modules/dine-in/useQueryParam";
import { showErrors } from "utils/Utils";

const usePayByPaymentMethod = (setcardProcessing=()=>{}, handleSuceessOrderRoute=()=>{}) => {
  const { brandInfo } = useSelector((state) => state.brandStorageReducer);
  const { logError, brand_based_place_order, outlet_based_place_order } =
    usePlaceOrderHelper(handleSuceessOrderRoute);
  const { DomainType , orderType } = useSelector((state) => state.AppReducer);
  const params = useParams();
  const queryParams = useQueryParam();
  const dispatch = useDispatch();

  let callBackFn = null;

  let fallBackMessage = "Bank declined payment, please try again";
  const currentUser = UTILS.getCurrentUser(brandInfo?.brand?._id);

  const process_payment_using_payby = async ({ placeMyOrder, ...payload }) => {
    try {
      const { isValid, errors } = UTILS.validateOutletOrderObject();
      if (!isValid) {
        showErrors(errors);
        return;
      }
      setcardProcessing(true);
      dispatch(
        PaymentMethodAction.setPaybyPaymentModalData({
          isLoading:true,
        })
      );
      const resp = await createPaymentIntent({
        ...payload,
        brand: { ...brandInfo?.brand },
        userRefId: currentUser?.user?.userId,
        params,
        DomainType,
        serviceType: orderType.serviceType || false,
        queryParams
      });
        
      if (resp?.data?.body) {
        dispatch(
          PaymentMethodAction.setPaybyPaymentModalData({
            isOpen: true,
            isLoading:false,
            data: resp?.data?.body,
          })
        );
        callBackFn = placeMyOrder;
      } else callBackFn = null;
    } catch (error) {
      logError(error?.message || fallBackMessage, true, "error");
    } finally {
      setcardProcessing(false);
    }
  };

  const process_payby_payment_brand_based = async ({
    amountTobePaid,
    selectedStore,
  }) => {
    process_payment_using_payby({
      amountTobePaid,
      selectedStore,
      placeMyOrder: brand_based_place_order,
    });
  };

  const process_payby_payment_outlet_based = async ({
    amountTobePaid,
    selectedStore,
  }) => {
    await process_payment_using_payby({
      amountTobePaid,
      selectedStore,
      placeMyOrder: outlet_based_place_order,
    });
  };

  return {
    process_payby_payment_outlet_based,
    process_payby_payment_brand_based,
  };
};

export default usePayByPaymentMethod;
